import { useState, useEffect } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useHomePage = () => {
  const [dishes, setDishes] = useState([]);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { authed, token } = useAuth();

  useEffect(() => {
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(`${apiRoot}/homepage`, {
      headers
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishes(json.dishes);
            setEvents(json.events);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setDishes([]);
          setEvents([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDishes([]);
        setEvents([]);
        setLoading(false);
      });
  }, [authed, token]);

  return {
    dishes,
    events,
    error,
    loading,
  };
};

export default useHomePage;
